import { IProgressTrackerStepProps } from "@starrez/starryui";
import { FormikProps } from "formik";
import * as Yup from "yup";

export interface IWizardStep {
    Show?: boolean;
    TrackerProps: IProgressTrackerStepProps;
    TrackerPanel: React.ReactElement<IWizardFormProps<IWizardExecuteAllModel>>;
    PreviousLabel?: string;
    NextLabel?: string;
    HideButtonBar?: boolean;
}

export interface IWizardFormProps<T extends IWizardExecuteAllModel> {
    FormikValues: T;
    FormikProps?: FormikProps<T>;
    ValidationSchema: Yup.ObjectSchema;
    IsShown?: boolean;
    SetHasValidationErrors?: (hasErrors: boolean) => void; // a callback function from the current step to the Wizard
    ShouldValidate?: boolean; // allows us to skip validation on the current step
}

export interface IWizardExecuteAllModel {
    ids?: number[];
    id?: number;
    formDataModel: IWizardExecuteDataModel;
}

export interface IWizardExecuteDataModel {
    transformData: () => void;
}

export interface IWizardHandler {
    _error: IWizardError;
}

export interface IWizardError {
    _autoFix: boolean;
    _autoIgnore: boolean;
}

export * from "./Wizard";
